<template>
  <div>
    <v-navigation-drawer
      v-model="visible"
      :permanent="visible"
      class="guidance"
      color="#1A1A1A"
      width="65%"
      disableOverlay
      fixed
      dark
    >
      <div class="guidance__container" v-if="page">
        <div class="guidance__toolbar px-6">
          <h1>{{ $t("guidance.toolbar") }}</h1>
          <v-spacer />
          <v-btn @click="visible = false" class="floating-button pa-5" icon>
            <v-icon class="button-icon">$iconClose</v-icon>
          </v-btn>
        </div>
        <div class="guidance__tabs-container" v-if="$te(`guidance.${page}`)">
          <div class="pa-0 guidance__tabs">
            <v-tabs
              :value="tab"
              background-color="#4C4C4C"
              class="guidance"
              @change="(value) => changeTab(value)"
              vertical
            >
              <v-tab
                v-for="(item, index) in $t(`guidance.${page}`)"
                :key="index"
              >
                {{ $t(`guidance.${page}[${index}].tab`) }}
              </v-tab>
            </v-tabs>
          </div>
          <div class="guidance__content pl-0 pt-0">
            <v-tabs-items :value="tab">
              <v-tab-item
                v-for="(item, index) in $t(`guidance.${page}`)"
                :key="index"
              >
                <div
                  class="py-4 px-6"
                  v-html="$t(`guidance.${page}[${index}].content`)"
                  v-if="$te(`guidance.${page}[${index}].content`)"
                />
                <div v-else>
                  <no-content />
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
        <div v-else>
          <no-content />
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { eventBus } from "@/components/EventBus";
import NoContent from "@/components/guidance/NoContent";

export default {
  name: "guidance",
  components: {
    NoContent,
  },
  data: function () {
    return {
      visible: false,
      page: "",
      tab: "",
    };
  },
  computed: {
    ...mapState("authStore", ["email", "firstname", "lastname"]),
  },
  methods: {
    changeTab(value) {
      this.tab = value;
      document.querySelector(".guidance__content").scrollTo(0, 0);
    },
  },
  watch: {
    $route() {
      this.visible = false;
    },
  },
  created() {
    eventBus.$on("toggleGuidance", (page) => {
      document.querySelector(".guidance__content")?.scrollTo(0, 0);
      if (this.page === page) {
        this.visible = !this.visible;
      } else {
        this.page = page;
        this.tab = this.$i18n.t(`guidance.${page}[0].tab`);
        this.visible = true;
      }
    });
  },
  destroyed() {
    eventBus.$off("toggleGuidance");
  },
};
</script>

<style lang="scss">
.guidance {
  max-width: 589px !important;
  z-index: 201 !important;

  &__container {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }

  &__toolbar {
    height: 72px;
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #4c4c4c;
    flex-shrink: 0;
  }

  &__tabs-container {
    display: flex;
    overflow: auto;
    height: 100%;
  }

  &__tabs {
    height: 100%;
    background: rgb(76, 76, 76);
    overflow: auto;
    flex-basis: 28%;
    flex-shrink: 0;
  }

  &__content {
    background: #1e1e1e;
    overflow: auto;
    flex-grow: 1;
  }

  h2 {
    font-weight: 700 !important;
    margin-bottom: 16px;
  }

  p {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    letter-spacing: 0.15px !important;
    margin-bottom: 16px !important;
  }

  img {
    max-width: calc(100% - 40px);
    margin: 0 20px 16px;
  }

  a {
    font-size: 14px;
  }

  .v-tabs-bar__content {
    transform: initial !important;
    width: 100%;
  }

  .v-tab {
    white-space: initial;
    text-align: left;
    width: 100%;
    padding: 12px 16px;
    height: auto !important;
    justify-content: flex-start;
    text-transform: initial;
    font-weight: 400 !important;

    &--active {
      border-right: 2px solid;
    }
  }

  .v-tabs-slider-wrapper {
    display: none;
  }

  &__content,
  &__tabs {
    &::-webkit-scrollbar {
      background-color: #202324;
      color: #aba499;
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #454a4d;
      border-radius: 100px !important;
      border: 2px solid #202324;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: #575e62;
    }
    &::-webkit-scrollbar-thumb:active {
      background-color: #484e51;
    }
    &::-webkit-scrollbar-corner {
      background-color: #181a1b;
    }
  }
}
</style>
